import React, { useCallback } from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'

import api from 'Src/api'

import { fetchBots } from 'Src/actions/bots'

const CREATE_BOTS_URL = 'v1/bot-profiles/create'
const CREATE_FLOW_URL = 'v1/bot-flows/create'

const CreateBotModal = ({ isOpen, hide }) => {
  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm()

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const onClose = useCallback(hide, [hide])

  const onFormSubmit = async (data) => {
    const botName = data.botName

    try {
      const botResponse = await api.post(CREATE_BOTS_URL, {
        name: botName,
        displayName: botName
      })

      const bot = botResponse.data.bot

      await api.post(CREATE_FLOW_URL, {
        botId: bot.id,
        name: 'Start'
      })

      dispatch(fetchBots())

      navigate(`/bots/${bot.id}`)
    } catch (err) {
      console.error('Error while creating a bot', err)
    }
  }

  return (
    <div>
      <Modal isOpen={isOpen} contentLabel='Create Bot Modal' ariaHideApp={false} onRequestClose={onClose}>
        <div className='modal-header'>
          <h2>Create Chatbot</h2>
          <div className='modal-close' onClick={onClose}>
            &times;
          </div>
        </div>
        <div className='modal-body'>
          <form onSubmit={handleSubmit(onFormSubmit)}>
            <div className='form-group'>
              <label>Give your chatbot a name</label>
              <input
                className={classNames('form-control', { 'is-invalid': errors.name })}
                name='botName'
                {...register('botName', {
                  required: 'Name is required',
                  minLength: {
                    value: 3,
                    message: 'Name should contain at least 3 characters'
                  }
                })}
              />
              {errors.name && <small className='form-text text-danger'>{errors.name.message}</small>}
            </div>
            <button className='button-primary' type='submit'>
              Create
            </button>
          </form>
        </div>
      </Modal>
    </div>
  )
}

export default CreateBotModal
